import gql from 'graphql-tag';

/**
 * Mutation to update a submission owned by the currently authenticated user.
 *
 * @param id - The submission ID to update (required)
 * @param updates - Submission update data including content title, URL, description, image, and credits (optional)
 * @returns Complete updated submission including order info, content details, credits, service info, and associated post
 * @usedIn Submission layout (edit submission form)
 */
export const UPDATE_MY_SUBMISSION = gql`
  mutation updateMySubmission($id: ID!, $updates: UpdateMySubmissionInput) {
    updateMySubmission(id: $id, updates: $updates) {
      orderNumber
      contentTitle
      contentUrl
      contentDescription
      status
      flagged
      createdAt
      submissionType
      terms
      order {
        paymentType
        amountPaid
        ccLast4
      }
      contentImage {
        sourceUrl
        sourceSet
      }
      post {
        title
        slug
      }
      credits {
        creditId
        creditType {
          typeName
        }
        name
        user {
          userId
          preferredUsername
        }
        socialMedia {
          type
          link
        }
      }
      service {
        serviceId
        name
      }
    }
  }
`;
